import React from 'react';

import { DefaultButton } from 'office-ui-fabric-react/lib/Button';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';

const stats = (props) => {
  const { plot, plotIndex } = props;
  return (
    <div className='filters panel-body'>
      <div style={{paddingRight: '37px'}}>
        <Checkbox 
          key='include-stats'
          label="Include All" 
          className='stat-checkbox'
          checked={plot.appliedFilters.stats}
          onChange={(e, checked) => props.changeFilter({stats: checked, ninetieth: checked, tenth: checked, fiftieth: checked, average: checked, min: checked, max: checked}, plotIndex, 'stats')} 
        />
        <Checkbox 
          key='include-ninetieth'
          label="Include Ninetieth Percentile" 
          className='stat-checkbox'
          checked={plot.appliedFilters.ninetieth}
          onChange={(e, checked) => props.changeFilter({ninetieth: checked}, plotIndex, 'stats')} 
        />
        <Checkbox 
          key='include-tenth'
          label="Include Tenth Percentile" 
          className='stat-checkbox'
          checked={plot.appliedFilters.tenth}
          onChange={(e, checked) => props.changeFilter({tenth: checked}, plotIndex, 'stats')} 
        />
        <Checkbox 
          key='include-fiftieth'
          label="Include Fiftieth Percentile" 
          className='stat-checkbox'
          checked={plot.appliedFilters.fiftieth}
          onChange={(e, checked) => props.changeFilter({fiftieth: checked}, plotIndex, 'stats')} 
        />
        <Checkbox 
          key='include-avg'
          label="Include Average" 
          className='stat-checkbox'
          checked={plot.appliedFilters.average}
          onChange={(e, checked) => props.changeFilter({average: checked}, plotIndex, 'stats')} 
        />
        <Checkbox 
          key='include-min'
          label="Include Minimum" 
          className='stat-checkbox'
          checked={plot.appliedFilters.min}
          onChange={(e, checked) => props.changeFilter({min: checked}, plotIndex, 'stats')} 
        />
        <Checkbox 
          key='include-max'
          label="Include Maximum" 
          className='stat-checkbox'
          checked={plot.appliedFilters.max}
          onChange={(e, checked) => props.changeFilter({max: checked}, plotIndex, 'stats')} 
        />
        <DefaultButton
          className='apply-filter'
          text="Apply"
          primary
          onClick={ () => props.applyFilters({...plot.appliedFilters}, plotIndex) }
        />
      </div>
    </div>
  )
};

export default stats;


// WEBPACK FOOTER //
// ./src/components/panel/items/stats.js